import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import WebsiteTunnelSwitcher from "./WebsiteTunnelSwitcher";
import { getAvailableStopoverCities } from "app/pages/SmartDP/smartDPSelectors";
import { fetchTunnelSearchFilters } from "./tunnelSearchFiltersActionCreators";

const WebsiteTunnelSwitcherContainer = props => {
	const stopoverCities = useSelector(getAvailableStopoverCities);
	const dispatch = useDispatch();

	const handleTunnelChange = useCallback(
		websiteTunnelType => {
			const searchFiltersAction = fetchTunnelSearchFilters({ websiteTunnelType });

			if (searchFiltersAction) {
				dispatch(searchFiltersAction);
			}
		},
		[dispatch]
	);

	return (
		<WebsiteTunnelSwitcher
			stopoverCities={stopoverCities}
			onTunnelChange={handleTunnelChange}
			{...props}
		/>
	);
};

export default WebsiteTunnelSwitcherContainer;
